module.exports = __webpack_public_path__ + "media/ITIRUM_FIGHT_WEBSITE_COMPRESSED.22ec7c6a.mp4";